const accentColor = "#5b2fd4";

export const accordionSx = {
  borderRadius: 0,
  border: "none",
  borderBottom: "1px solid #e0e0e0",
  borderLeft: "3px solid transparent",
  backgroundColor: "#ffffff",
  boxShadow: "none",
  transition: "border-left-color 0.15s ease",
  "&.Mui-expanded": {
    boxShadow: "none",
    margin: 0,
    borderLeftColor: accentColor,
  },
  "&:hover": {
    borderLeftColor: accentColor,
  },
  "&:before": { display: "none" },
};

export const summarySx = {
  px: 2,
  py: 0.75,
  minHeight: 44,
  backgroundColor: "transparent",
  "&.Mui-expanded": { backgroundColor: "transparent" },
  "&:hover": { backgroundColor: "rgba(0,0,0,0.015)" },
  "& .MuiAccordionSummary-content": { margin: 0 },
};

export const detailsSx = {
  p: 0,
  borderTop: "1px solid #eeeeee",
};

export const sectionDisabledSx = (disabled) => ({
  opacity: disabled ? 0.6 : 1,
  pointerEvents: disabled ? "none" : "auto",
});